export enum POPUP_MESSAGES {
  UploadReportingBundleSuccess = "Shifts reporting bundle has been uploaded.",
  ApproveAndReleaseShiftsSuccess = "Shifts have been approved and released.",
  ApproveAndReleaseShiftsWarning = "Already submitted shifts for this week. Submitting duplicate shifts will be difficult to clean up. Continue?",
  ValidateShifterPipelineSuccess = "Shifts have been validated.",
  PublishPipelineSuccess = "Shifts have been published.",
}
